import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './css/CadastrarModelo.css';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import CardNotification from '../components/CardNotification';
import LegendaText from '../components/LegendaText';

import { EditorState, convertToRaw} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html'; 
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'; 

const CadastrarModelo = () => {
    const navigate = useNavigate();
    const [nomeModelo, setNomeModelo] = useState('');
    const [imagem, setImagem] = useState(null);
    const [editorState, setEditorState] = useState(EditorState.createEmpty()); 
    const [notification, setNotification] = useState({ message: '', type: '', show: false });
    let id_instituicao = localStorage.getItem("id_instituicao");


    const handleImagemUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImagem(file);
        }
    };

    const handleNomeChange = (event) => {
        setNomeModelo(event.target.value);
    };


    const handleEditorChange = (newState) => {
        setEditorState(newState);
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
    
        try {
            const contentState = editorState.getCurrentContent();
    
            if (!contentState.hasText()) {
                alert('Por favor, insira um texto válido!');
                return;
            }
    
            const htmlContent = draftToHtml(convertToRaw(contentState));
            const formData = new FormData();
            formData.append('id_instituicao', id_instituicao);
            formData.append('nome_modelo', nomeModelo);
            formData.append('modelo_foto', imagem);
            formData.append('texto', htmlContent);
            
            let response = await axios.post(`${process.env.REACT_APP_API_URL}/modelos`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                withCredentials:true,
            });

    
            setNotification({
                message: `Modelo cadastrado com sucesso!`,
                type: 'success',
                show: true,
            });
    
        } catch (error) {
            console.error('Erro ao cadastrar ou atualizar modelo:', error);
            setNotification({
                message: 'Erro ao processar a solicitação. Tente novamente.',
                type: 'error',
                show: true,
            });
        }
    };
    
    

    const closeNotification = () => {
        setNotification({ ...notification, show: false });
    };

    return (
        <div>
            <Header />
            <Sidebar />
            <div className="cadastrar-modelo-container">
                <div className="voltar-container" onClick={() => navigate('/list-modelo')}>
                    &#8592; <span>Voltar para Modelos</span>
                </div>

                <h1>Cadastrar Modelo de Certificado</h1>

                {notification.show && (
                    <CardNotification 
                        message={notification.message} 
                        type={notification.type} 
                        onClose={closeNotification} 
                    />
                )}

                <form onSubmit={handleSubmit} className="cadastrar-modelo-form">
                    <label className="cadastrar-modelo-label">Nome do Modelo:</label>
                    <input 
                        type="text" 
                        value={nomeModelo} 
                        onChange={handleNomeChange} 
                        placeholder="Digite o nome do modelo"
                        className="cadastrar-modelo-input"
                    />


                    <label className="cadastrar-modelo-label">Texto do Modelo:</label>
                    <div className="cadastrar-modelo-texto-legenda">
                        <Editor
                            editorState={editorState}
                            onEditorStateChange={handleEditorChange}
                            toolbar={{
                                options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'history'],
                                inline: {
                                options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace'],
                                },
                                blockType: {
                                options: ['Normal', 'H1', 'H2', 'H3', 'blockquote'],
                                },
                                fontSize: {
                                options: [8, 10, 12, 14, 16, 18, 24, 30, 48],
                                },
                                colorPicker: {
                                colors: ['#000000', '#FF0000', '#00FF00', '#0000FF', '#FFA500', '#800080'],
                                },
                                textAlign: {
                                options: ['left', 'center', 'right', 'justify'],
                                },
                                list: {
                                options: ['unordered', 'ordered'],
                                },
                                history: {
                                options: ['undo', 'redo'],
                                },
                            }}
                            />

                        <LegendaText />
                    </div>



                    <label className="cadastrar-modelo-label">Upload do Background:</label>
                    <input 
                        type="file" 
                        accept="image/*" 
                        onChange={handleImagemUpload} 
                        required 
                        className="cadastrar-modelo-input"
                    />

                    <div className="cadastrar-modelo-preview-container">
                        {imagem ? (
                            <img src={URL.createObjectURL(imagem)} alt="Pré-visualização" className="cadastrar-modelo-preview" />
                        ) : (
                            <div className="cadastrar-modelo-preview-simulado">
                                <span>Pré-visualização da imagem</span>
                            </div>
                        )}
                    </div>

                    <button type="submit" className="cadastrar-modelo-button">Cadastrar Modelo</button>
                </form>
            </div>
        </div>
    );
};

export default CadastrarModelo;
